var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDroptrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rupee-1-frame-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6996 4.45082H13.7894L14.9167 2.5H4.04413L2.91678 4.45082H7.09292C8.01388 4.72844 8.76247 5.2859 9.17637 5.99348H4.04413L2.91675 7.9443H9.43102C9.04466 9.27651 7.55058 10.2694 5.76506 10.2694H3.53815V12.0276L9.85724 17.5H12.6087V16.8197L6.83432 11.9317C9.2575 11.8335 11.2371 10.1382 11.5995 7.94427H13.7894L14.9167 5.99345H11.487C11.3258 5.43051 11.0557 4.90984 10.6996 4.45082Z",
    fill: "#9CA3AF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5561 14.0282V9.1665H14.1664V14.0282H12.0835L14.8613 17.4998L17.6391 14.0282H15.5561Z",
    fill: "#9CA3AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroptrack);
export default __webpack_public_path__ + "static/media/Droptrack.18ccc234a3cac208ae61d991c4bd479c.svg";
export { ForwardRef as ReactComponent };